module.exports = __webpack_public_path__ + "img/corto_sx.4b525e46.png";